var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-relation',_vm._b({ref:"relationPoll",staticClass:"relation-image",attrs:{"answer-key":"id"},scopedSlots:_vm._u([{key:"timer",fn:function(){return [_vm._t("timer")]},proxy:true},{key:"titleContent",fn:function(ref){
var titleItem = ref.titleItem;
return [_c('img',{attrs:{"src":titleItem.image,"alt":""}})]}},{key:"variantContent",fn:function(ref){
var variantItem = ref.variantItem;
return [_vm._v(" "+_vm._s(variantItem.title)+" ")]}}],null,true)},'base-relation',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }